import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { LinksCta, PolicyPageLoaded } from '@analytics/store';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  fadeInOut,
  ItemOffer,
  Offers,
  ReplacementOffer,
} from '@dgx-pr-spa/shared/util';
import { Store } from '@ngrx/store';
import { getPdfPaths } from '@shared/helpers/get-pdf-paths';

@Component({
  selector: 'app-add-protection',
  templateUrl: './add-protection.component.html',
  styleUrls: ['./add-protection.component.scss'],
  animations: [fadeInOut],
})
export class AddProtectionComponent implements OnInit, AfterViewInit {
  constructor(
    public readonly additionalServicesService: AdditionalServicesService,
    public readonly router: Router,
    private elementRef: ElementRef,
    private store: Store
  ) {}
  /**
   * Receives complete offers data
   */
  @Input() offers: Offers;

  /**
   * Receives the selected offer
   */
  @Input() selected: ReplacementOffer;

  /**
   * Receives item offer data
   */
  @Input() itemOffer: ItemOffer;

  protectionPanels = [
    {
      body: `From snaps and cracks to bumps and whacks – when accidents happen,
            we’ll cover the repair costs.`,
      icon: 'shield-check',
      title: 'Immediate cover for accidental damage',
    },
    {
      body: `Book as many repairs as you need, with no extra cost for parts,
            labour or call-outs. We also cover breakdowns after your
            manufacturer’s guarantee.`,
      icon: 'screwdriver-wrench',
      title: 'There’s no limit to repairs',
    },
    {
      body: `If we can’t fix your appliance, we’ll arrange a replacement with the same or similar features (excluding any installation or disposal costs).
            In some cases we may be able to offer an improved model, for an additional fee.`,
      icon: 'dolly',
      title: ' If it’s not fixable, we’ll replace it like we did today',
    },
  ];

  showWarning = false;

  pdfFolderPath!: {
    termsAndConditions: string;
    ipid: string;
  };

  ngOnInit() {
    this.scrollIntoView('body', 'smooth');
    this.additionalServicesService.resetProtection();
    this.store.dispatch(PolicyPageLoaded());
    this.setDocumentLink();
  }

  ngAfterViewInit() {
    // TODO: allow dgx-component accordion to have state opened by default.
    const accordionTerms: HTMLElement[] =
      this.elementRef.nativeElement.querySelectorAll(
        '.add-protection__terms .accordion-panel__header'
      );

    setTimeout(() => {
      accordionTerms.forEach((item) => item.click(), 100);
    });
  }

  setDocumentLink(schemeCode = this.offers?.current_plan?.scheme_code): void {
    this.pdfFolderPath = getPdfPaths(schemeCode);
  }

  addProtection(addProtection: boolean, label: string) {
    this.store.dispatch(
      LinksCta({
        label,
        eventAction: `CTA clicks - your policy${
          this.showWarning ? ' -popup' : ''
        }`,
        includeMetaData: !addProtection,
      })
    );

    if (addProtection) {
      this.additionalServicesService.addProtection();
      this.routeToConfirm();
    }

    if (!addProtection && this.showWarning) {
      this.additionalServicesService.resetProtection();
      this.routeToConfirm();
    }

    this.showWarning = !this.showWarning;
    this.scrollIntoView('warning', 'smooth');
  }

  routeToConfirm() {
    this.router.navigate(['/complete-order'], {
      queryParamsHandling: 'preserve',
    });
  }

  scrollIntoView(id: string, behavior?: ScrollBehavior) {
    document.getElementById(id)?.scrollIntoView({
      behavior,
      block: 'start',
      inline: 'nearest',
    });
  }

  trackEvent(linkType: 'policy' | 'insurance'): void {
    const mappedLinkText = {
      policy: 'Policy Terms & Conditions',
      insurance: 'Insurance Product Information Document (IPID)',
    };

    this.store.dispatch(
      LinksCta({
        label: mappedLinkText[linkType],
        eventAction: 'CTA clicks - your policy',
      })
    );
  }
}
